<template>
  <div class="dashboard-container">
    <el-row :gutter="20">
      <el-col :span="12">
        <el-card>
          <div class="card-header">
            <span>用户增长趋势</span>
          </div>
          <div class="card-body">
            <div ref="userChart" style="width: 100%; height: 200px;"></div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card>
          <div class="card-header">
            <span>订单统计</span>
          </div>
          <div class="card-body">
            <div ref="orderChart" style="width: 100%; height: 200px;"></div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="20" style="margin-top: 20px;">
      <el-col :span="12">
        <el-card>
          <div class="card-header">
            <span>彩种销售占比</span>
          </div>
          <div class="card-body">
            <div ref="lotteryChart" style="width: 100%; height: 200px;"></div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card>
          <div class="card-header">
            <span>代理业绩</span>
          </div>
          <div class="card-body">
            <div ref="agentChart" style="width: 100%; height: 200px;"></div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'Dashboard',
  mounted() {
    this.initCharts();
  },
  methods: {
    initCharts() {
      // 用户增长趋势
      const userChart = echarts.init(this.$refs.userChart);
      userChart.setOption({
        xAxis: {
          type: 'category',
          data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月']
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: [120, 200, 150, 80, 70, 110, 130],
          type: 'line'
        }]
      });

      // 订单统计
      const orderChart = echarts.init(this.$refs.orderChart);
      orderChart.setOption({
        xAxis: {
          type: 'category',
          data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月']
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: [820, 932, 901, 934, 1290, 1330, 1320],
          type: 'bar'
        }]
      });

      // 彩种销售占比
      const lotteryChart = echarts.init(this.$refs.lotteryChart);
      lotteryChart.setOption({
        tooltip: {
          trigger: 'item'
        },
        series: [{
          name: '彩种销售占比',
          type: 'pie',
          radius: '50%',
          data: [
            { value: 1048, name: '双色球' },
            { value: 735, name: '大乐透' },
            { value: 580, name: '3D' },
            { value: 484, name: '排列三' },
            { value: 300, name: '其他' }
          ]
        }]
      });

      // 代理业绩
      const agentChart = echarts.init(this.$refs.agentChart);
      agentChart.setOption({
        xAxis: {
          type: 'category',
          data: ['代理A', '代理B', '代理C', '代理D', '代理E']
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: [1200, 800, 1500, 900, 1100],
          type: 'bar'
        }]
      });
    }
  }
}
</script>

<style scoped>
.dashboard-container {
  padding: 20px;
  height: calc(100vh - 60px); /* 减去顶部 header 的高度 */
}
.card-header {
  font-size: 16px;
  font-weight: bold;
}
.card-body {
  text-align: center;
  padding: 20px 0;
}
</style>